import clsx from 'clsx';

export function Card({ className, children, ...props }) {
  return (
    <div className={clsx('card p-5', className)} {...props}>
      {children}
    </div>
  );
}

export function StatCard({ icon: Icon, label, value, hint, color = 'brand' }) {
  const colors = {
    brand: 'from-brand-500 to-indigo-500',
    emerald: 'from-emerald-500 to-teal-500',
    rose: 'from-rose-500 to-pink-500',
    amber: 'from-amber-500 to-orange-500',
    violet: 'from-violet-500 to-purple-500',
    sky: 'from-sky-500 to-cyan-500',
  };
  return (
    <Card className="flex items-center gap-4">
      <div className={clsx('w-12 h-12 rounded-xl grid place-items-center text-white bg-gradient-to-br', colors[color])}>
        {Icon && <Icon size={22} />}
      </div>
      <div>
        <div className="text-sm text-slate-500">{label}</div>
        <div className="text-2xl font-bold leading-tight">{value}</div>
        {hint && <div className="text-xs text-slate-400 mt-0.5">{hint}</div>}
      </div>
    </Card>
  );
}
